"use strict";
import "lodash";
import moment from "moment";
import { svc_addOne, svc_editOne, svc_fetchOne, svc_search } from "@/services";
import { showServerResponse } from "@/utils/message";
import { convertISODateTimeToString } from "@/utils/convertTime";
import appConfig from "@/../config/config.json";

const endpointBasePrefix = "delivery/config";

const Model = {
    namespace: "m_DeliveryConfig",
    state: {
        config: {},
        configs: [],
    },
    reducers: {
        handleFetchAll(state, { payload: { configs } }) {
			return { ...state, configs };
		},
		handleFetchOne(state, { payload: { result } }) {
			return { ...state, config: result };
		},
    },
    effects: {
        *fetchAll({ payload }, { call, put }) {
			if (payload.config_id) {
				payload.search = payload.config_id;
				delete payload.config_id;
			}

			let configs = yield call(svc_search, `${endpointBasePrefix}`, payload);

			_.forEach(configs.result, function (row) {
				row.key = row.id;
				row = convertISODateTimeToString(row, ["enabled_from"], appConfig.dateFormat);
				row = convertISODateTimeToString(row, ["menu_sync_time", "created_at", "updated_at"], appConfig.dateTimeFormat);

				if (row.is_enabled)
					row.hideEnableBtn = true;
				if (!row.is_enabled)
					row.hideDisableBtn = true;
			});

			yield put({
				type: "handleFetchAll",
				payload: { configs },
			});

			return configs;
		},

        *addOne({ payload }, { call }) {
            const response = yield call(svc_addOne, endpointBasePrefix, payload);
            showServerResponse(response);
            return response;
        },

		// special endpoint just for checking if config has been created
		*checkOne({ searchKey }, { call }) {
			const response = yield call(svc_fetchOne, endpointBasePrefix, searchKey);
			return response;
		},

		*editOne({ payload }, { call }) {
			payload = _.omit(payload, ["key"]);
			// convert enabled date before sending
			payload.enabled_from = moment(payload.enabled_from, appConfig.dateFormat).format("YYYY-MM-DD");
			
			const response = yield call(svc_editOne, endpointBasePrefix, payload, "id");
			return showServerResponse(response);
		},
    },
    subscriptions: {},
};

export default Model;
